module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Light.eot?v=651bc6ce4288d8ec41715d768f671767";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Light.eot?
// module id = 653
// module chunks = 0